module.exports = __webpack_public_path__ + "img/jdjbicon2.e7034e1f.png";